import { motion, Variants, Easing } from "framer-motion";
import { openContactForm } from "../../Functions/contactFormFunctions";
import Section from "../Common/Section";
import Card from "../Common/Card";
import "./style.scss";

interface OurServicesSimpleProps {
  order?: "odd" | "even";
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" as Easing },
  },
};

const OurServicesSimple: React.FC<OurServicesSimpleProps> = ({ order }) => {
  return (
    <Section variant={order} className="ourServicesSimple">
      <motion.div className="sectionHeader" variants={itemVariants}>
        <h2 className="title">Our Services</h2>
        <p className="description">
          We provide professional cleaning solutions tailored to your needs.
          Feel free to{" "}
          <span className="enquiryLink" onClick={() => openContactForm()}>
            Enquire Now
          </span>{" "}
          for a custom quote.
        </p>
      </motion.div>

      <motion.div className="servicesGrid" variants={containerVariants}>
        <Card
          as="a"
          href="#DomesticWindows"
          className="serviceCard"
          variants={itemVariants}
        >
          <span className="material-symbols-outlined icon">home</span>
          <p className="cardTitle">Domestic Window Cleaning</p>
          <p className="cardText">
            Streak-free cleaning for your home's windows using traditional and
            modern methods.
          </p>
        </Card>
        <Card
          as="a"
          href="#CommercialWindows"
          className="serviceCard"
          variants={itemVariants}
        >
          <span className="material-symbols-outlined icon">business</span>
          <p className="cardTitle">Commercial Window Cleaning</p>
          <p className="cardText">
            Reliable cleaning for shops, offices, and commercial properties in
            Farnham.
          </p>
        </Card>
        <Card
          as="a"
          href="#ConservatoryRoofs"
          className="serviceCard"
          variants={itemVariants}
        >
          <span className="material-symbols-outlined icon">roofing</span>
          <p className="cardTitle">Conservatory Roof Cleaning</p>
          <p className="cardText">
            Specialist cleaning for conservatory glass and roofs to restore
            clarity.
          </p>
        </Card>
        <Card
          as="a"
          href="#GutterCleaning"
          className="serviceCard"
          variants={itemVariants}
        >
          <span className="material-symbols-outlined icon">house_siding</span>
          <p className="cardTitle">Gutter Cleaning</p>
          <p className="cardText">
            Debris removal and maintenance to prevent blockages and water
            damage.
          </p>
        </Card>
      </motion.div>
    </Section>
  );
};

export default OurServicesSimple;
